var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircles2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 520,
    viewBox: "0 0 520 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 260,
    r: 259,
    stroke: "#222222",
    strokeOpacity: 0.2,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.66 259.57C447.66 363.45 363.449 447.661 259.569 447.661C155.69 447.661 71.4785 363.45 71.4785 259.57C71.4785 155.691 155.69 71.4795 259.569 71.4795C363.449 71.4795 447.66 155.691 447.66 259.57Z",
    stroke: "#222222",
    strokeOpacity: 0.2,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles2);
export default __webpack_public_path__ + "static/media/Circles2.998a94c181edcf6a735a0f9d6727d300.svg";
export { ForwardRef as ReactComponent };